import apiClient from './apiClient';

/** Account-level SSH public keys (/api/user/ssh-keys). */
const call = async (fn) => {
    try {
        return (await fn()).data;
    } catch (error) {
        return { status: 'error', msg: error.response?.data?.msg || error.message };
    }
};

const sshKeyService = {
    list: () => call(() => apiClient.get('/api/user/ssh-keys')),
    add: (data) => call(() => apiClient.post('/api/user/ssh-keys', data)),
    generate: (data) => call(() => apiClient.post('/api/user/ssh-keys/generate', data)),
    rename: (id, name) => call(() => apiClient.post(`/api/user/ssh-keys/${id}/rename`, { name })),
    remove: (id) => call(() => apiClient.post(`/api/user/ssh-keys/${id}/delete`)),
};

export default sshKeyService;
